import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog } from '../../../components/AlertDialog';

interface ConfirmDisableDialogProps {
  open: boolean;
  accountName: string;
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmDisableDialog = ({
  open,
  accountName,
  onConfirm,
  onClose,
}: ConfirmDisableDialogProps) => {
  const { t } = useTranslation();

  return (
    <AlertDialog
      variant="alert"
      open={open}
      onClose={onClose}
      title={t('accounts.confirmDisableTitle')}
      description={t('accounts.confirmDisableMessage', {
        accountName,
      })}
      actions={{
        cancel: {
          label: t('general.cancel'),
          onClick: onClose,
        },
        confirm: {
          label: t('accounts.disable'),
          onClick: onConfirm,
        },
      }}
    />
  );
};
